import { createFileRoute } from "@tanstack/react-router"
import { AdminListingsPanel } from "@/components/directory-admin/admin-listings-panel"

export const Route = createFileRoute("/_authed/admin/listings")({
  component: AdminListingsPanel,
})
